module.exports = __webpack_public_path__ + "img/chicken-meal-1.a5e42da3.jpg";